import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TestRackSetupComponent } from './components/test-rack-setup/test-rack-setup.component';
import { TestRackSetupService } from "@catmodules/models/test-rack/services/test-rack-setup.service";
import { UIBaseModule } from "@catui/ui-base.module";
import {UIFormModule} from "@catuiform/ui-form.module";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import { TestRackZoneAssignmentComponent } from './components/test-rack-zone-assignment/test-rack-zone-assignment.component';
import {ZoneAssignmentService} from "app/modules/models/test-rack/services/zone-assignment.service";
import {TestRackService} from "app/modules/models/test-rack/services/test-rack.service";
import { TestRackUnitAssignmentComponent } from './components/test-rack-unit-assignment/test-rack-unit-assignment.component';
import {
  ButtonModule,
  CheckboxModule, DataTableModule, MessageModule,
  MessagesModule
} from "primeng/primeng";

import {AccordionModule} from "primeng/components/accordion/accordion";
import { PatchFieldLinksComponent } from './components/patch-field-links/patch-field-links.component';

const publicComponents = [
  TestRackSetupComponent,
  TestRackZoneAssignmentComponent,
  TestRackUnitAssignmentComponent,
  PatchFieldLinksComponent
];

const declarations = [
  ...publicComponents,
];

const imports = [
  CommonModule,
  FormsModule,
  UIBaseModule,
  UIFormModule,
  ReactiveFormsModule,
  DataTableModule,
  MessagesModule,
  MessageModule,
  CheckboxModule,
  ButtonModule
];

const exportings = [...publicComponents];

const providers = [
  TestRackSetupService,
  TestRackService,
  ZoneAssignmentService
];
const entryComponents = [...publicComponents];

@NgModule({
  declarations,
  entryComponents,
  exports: exportings,
  imports,
  providers,
})
export class TestRackModule { }



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/models/test-rack/test-rack.module.ts